import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  Input,
  EventEmitter,
  Output,
} from '@angular/core'
import { ICON_TYPE, LaunchDialogService } from '@spartacus/storefront'

import { Router } from '@angular/router'
import { GlobalMessageType, GlobalMessageService } from '@spartacus/core'
import { CommonService } from '../../../../shared/services/common.service'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'
import { PRE_URL } from '../../../../shared/constants'

@Component({
  standalone: false,
  selector: 'app-delete-saved-cart-dialog',
  templateUrl: './delete-saved-cart-dialog.component.html',
  styleUrls: ['./delete-saved-cart-dialog.component.scss'],
})
export class DeleteSavedCartDialogComponent implements OnInit {
  iconTypes = ICON_TYPE
  modalIsOpen = false

  currentUser = null

  currentCart = null

  @Output() deleteStatus = new EventEmitter()

  @ViewChild('dialog', { read: ElementRef })
  dialog: ElementRef

  constructor(
    private launchDialogService: LaunchDialogService,
    private commonService: CommonService,
    public router: Router,
    private globalMessageService: GlobalMessageService
  ) {}

  ngOnInit() {
    this.launchDialogService.data$.subscribe((data) => {
      this.currentUser = data.currentUser
      this.currentCart = data.currentCart
    })
  }

  dismissModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.DELETE_SAVED_CART,
      reason: reason,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }

  deleteCart() {
    if (!this.currentUser.uid || !this.currentCart.code) {
      return
    }
    this.commonService
      .patchData(
        `${PRE_URL}/users/current/${this.currentCart.code}/deleteSavedCarts`,
        {},
        {}
      )
      .subscribe(
        () => {
          // this.globalMessageService.add('Your profile has been updated. However, the changes you have made will not reflect in the current cart. They will be available in the next cart that is created.', GlobalMessageType.MSG_TYPE_CONFIRMATION, 90000);

          window.scroll(0, 0)
          let deleteStatus = {
            deleteSuccess: true,
            cartName: this.currentCart.name,
          }
          const dialogResponse: DialogResponse = {
            type: VS_LAUNCH_CALLER.DELETE_SAVED_CART,
            data: deleteStatus,
            reason: 'Saved cart deleted',
          }
          this.launchDialogService.closeDialog(dialogResponse)

          this.globalMessageService.add(
            {
              key: 'savedCart.cartDeleteSuccess',
              params: { cartName: this.currentCart.name },
            },
            GlobalMessageType.MSG_TYPE_CONFIRMATION,
            9000
          )
          window.scrollTo(0, 0)
          this.router.navigate(['saved-carts'])
        },
        (err) => {
          this.globalMessageService.add(
            {
              key: 'savedCart.deleteCartFailed',
              params: {
                errorMsgJson: err.message,
              },
            },
            GlobalMessageType.MSG_TYPE_ERROR,
            10000
          )
          window.scrollTo(0, 0)
        }
      )
  }
}
